module.exports = __webpack_public_path__ + "5a852e86c2c40c87b0339221e564d928.woff";